import React from 'react'
import moment from 'moment'
import style from './style.css'

export default class TimeLabels extends React.Component {

  static labelFor( time, millis ) {
    // let d = moment.duration( 1000*Math.floor(time/1000))._data
    const d = moment.duration( time )._data
    let l = `${( d.hours > 0 ? `${pad( d.hours )}:` : '' ) + pad( d.minutes )}:${pad( d.seconds )}`
    if ( millis && d.milliseconds > 0 ) {
      const ms = ( d.milliseconds / 1000 ).toFixed( 2 ).toString()
      const index = ms.indexOf( '.' )
      l += `.${ms.substring( index + 1 )}`
    }
    return l
  }

  constructor( props ) {
    super( props )
    this.state = { currentTime : 0, scrollLeft : 0 }
  }

  render() {
    const { timeCalc } = this.props
    const { currentTime, scrollLeft } = this.state

    const num = 20
    // if ( this.element ) {
    //   num = this.element.parentNode.offsetWidth / (3*timeCalc.keyframeSize)
    // }

    const off = scrollLeft // timeCalc.timeToX( currentTime ) - timeCalc.keyframeSize / 2
    const startTime = 3 * timeCalc.scale * Math.floor( ( currentTime ) / ( timeCalc.scale * 3 ) )
    const lbls = []
    const cOff = 30

    for ( let n = 0; n < num; n++ ) {
      // let t = currentTime + (n * timeCalc.scale * 3 )
      // let x = timeCalc.timeToX( t ) - off
      const t = startTime + ( n * timeCalc.scale * 3 )
      const x = timeCalc.timeToX( t ) - off
      const l = TimeLabels.labelFor( t )
      lbls.push( <div key={n} className={style.timeLabel} style={{ left : Math.max( x - cOff, -10 ) }}>{l}</div> )
    }
    return (
      <div className={style.timelineLabels} ref={e => this.element = e}>
        {lbls}
      </div>
    )
  }

}

function pad( n ) {
  return n < 10 ? `0${n}` : n
}
